import React from 'react';
import { connect } from 'react-redux';
import AdCaller from 'helpers/ads/adCaller';
import _get from 'lodash.get';
import throttle from 'lodash.throttle';
import smoothScroll from 'smoothscroll';
import Cookie from 'utils/cookies';
import {
  PRC_FOR_NEVER_REGISTER,
  // IPL_MID_ARTICLE,
  BACK_BUTTON_LISTING_STORAGE_NAME,
} from 'constants/index';
import {
  preventCopy,
  isTablet,
  inViewForReact,
  // getGeoBasesPerpectualNextLinkData,
  isIPLMidArticleWidgetsPresent,
  // getAuthors,
  fireCustomDimension,
  getCustomDimension45,
  fireGA4ScriptPerpectual,
  postCreditScoreMessage,
  getSectionForPathName,
} from 'utils/common';
import {
  getExperimentRefresh,
  refreshEventsClearTimeout,
  runAbExperiment,
} from 'utils/experimentUtils';
import PropTypes from 'prop-types';
import { refreshDfpAdsFromRefreshableList } from 'helpers/ads/redux';
import { gaWrapper } from 'helpers/analytics';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
// import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import { isPrimeNotActive } from 'utils/primeUtil';
//import LinksList from 'components_v2/desktop/LinksList';
import { openSidebar } from 'reduxUtils/modules/comments';
import { updateOpenAppUrl } from 'reduxUtils/modules/navigation';
import { showMiniTvPlayer } from 'modules/WithMiniTv/redux';
import { toggleOpenInApp } from 'reduxUtils/modules/common';
import AffiliatesContent from 'components/AffiliatesContent';
import { toggleLoginBox } from 'components/Login/redux';
import {
  // toggleNIC,
  // loadNIC,
  // setNICLabel,
  loadArticleshowData,
  loadArticleshowDataNew,
  updateActiveMsid,
  openVideoTheatre,
  closeVideoTheatre,
  loadVideoTheatreSlider,
  addNextVideoMsid,
  setIsOrganic,
  setIsPaidTraffic,
  loadNewSectionInfo,
  populateArticleshowWidgets,
} from 'routes/articleshow_v2/redux';
import { getGAData } from 'routes/articleshow/utils/getGAData';
import { setGrxParamsRelatedToData, setGrxParams } from 'utils/setGrxData';
import {
  getWidgetMapping,
  getEtimesWidgetMapping,
} from 'routes/articleshow_v2/config';

import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen/PrimeScreen';
//import { loadFewCentJs, fewcentPaywall } from 'utils/fewcents';
// import ArticleshowIPLWidgetsLoadable from 'routes/articleshow/components/ArticleshowIPLWidgets/ArticleshowIPLWidgets';
// import AdFreeNudge from 'components/AdFreeNudge/';
// import GenderPopupLoader from 'components_v2/common/GenderPopup';
// import TimesClubWidgetLoader from 'components_v2/common/TimesClubWidget/TimesClubWidgetLoader';
// import WithPopup from 'modules/WithPopup';
import Loadable from 'react-loadable';
import {
  checkIfArticleToShowLimitBreached,
  addItemToArticleCounter,
  isFromDirectSource,
  setLoginSuccessInSessionStorage,
  getItemFromLocalStorage,
} from 'routes/articleshow/utils/articleBlocker';
import { loginEventEmitter } from 'components/Login/LoginUtils';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import { earnAboundPoints } from 'components_v2/common/Abound/redux';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import Audio from 'components_v2/common/Audio/Audio';
import LoginSuccessful from '../../components/common/LoginSuccessful';
import WithTrendingVideo from '../../components/common/TrendingVideo/WithTrendingVideo';
import StickyOpenInApp from '../../components/common/StickyOpenInApp/StickyOpenInApp';
// import MoreFromToi from '../../components/common/MoreFromToi/MoreFromToi';
// import StickyHeader from '../../components/desktop/StickyHeader';
import ArticleshowInner from './ArticleshowInner';
import s from './Articleshow_v2.scss';
import {
  addMspGaTrigger,
  isOrganicArticle,
  getPaidReferrer,
} from '../../utils/mspUtils';
import LoadableComponentLoader from '../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import LoaderSpinner from '../../../../components_v2/common/LoaderSpinner/LoaderSpinner';

const EVENT_NAME_ON_PERPETUAL = 'ON_PERPETUAL_VIEW';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Articleshowcard' */ '../../../articleshowcard'),
  loading: () => null,
  // timeout: 50000,
});

const MoreStoriesLoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'MoreStoriesListing' */ '../../components/desktop/MoreStoriesListing'),
  loading: () => null,
});

// const AdfreeNudgeWithPopup = WithPopup(AdFreeNudge);
// const GenderPopupLoaderWithPopup = WithPopup(GenderPopupLoader);
// const TimesClubWidgetLoaderWithPopup = WithPopup(TimesClubWidgetLoader);

function getWebUrl(url) {
  if (typeof window === 'undefined') {
    return url;
  }
  const origin = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`;
  const updatedUrl = url.replace('https://timesofindia.indiatimes.com', origin);
  return updatedUrl;
}

class Articleshow extends React.Component {
  constructor(props) {
    super(props);
    this.enablePersonalisePerpetual = false;
    // if (
    //   typeof window !== 'undefined' &&
    //   window.location.href.indexOf('/world') > -1
    // ) {
    //   this.enablePersonalisePerpetual = true;
    // }
    this.state = {
      // showforcenudge: false,
      activeMsid: '',
      enablePerpetual: false,
      textSize: 'medium',
      // finalNextLinks: this.props.articleData[this.props.msid].nextLinks,
      // finalNextLinks: {},
      finalNextLinks: this.enablePersonalisePerpetual
        ? {}
        : this.props.articleData[this.props.msid].nextLinks,
      isClientSide: false,
      isIPLMidArticleWidgetPresent: false,
      articlesToBlockList: [],
      showLoginSuccessMsgAfterBlocker: false,
      blockerStatusCheckedArr: [],
      nextArticleIndex: 1,
      showNextArticlePopUp: false,
      showBackButtonListing: false,
      // isStickyHeaderVisible: false,
      // readNextApiFailEventCaptured: {},
    };
    this.articlesLoaded = false;
    this.scrollVal = 0;
    this.lastDataFetchIndex = -1;
    this.pageViewFiredArr = [];
    this.tpActivityFired = false;
    this.mainArticlePageViewGASent = false;
    this.fillASReadListHandled = false;
    this.mainArticleBlockChecked = false;
    this.scrollDepthAcheivedArr = [];
    this.enableNextArticleSticky = false;
    this.worldSecrtionMsid = '296589292';
    this.lastArticleLoadedIndex = 0;
  }

  componentDidMount() {
    window.showAdFreeNudge = this.showForceNudge;
    const {
      currentCountry,
      abTestExperimentId = {},
      abAdskey: adName,
    } = this.props;
    const { abTestUpNextId = '' } = abTestExperimentId || {};
    runAbExperiment(abTestUpNextId, adName, {
      1: () => {
        this.enableNextArticleSticky = true;
      },
    });
    getExperimentRefresh(this.props.refreshTime);
    this.setDfpTargetingKeyword();
    // if (!this.props.isAppView) {
    //   loadFewCentJs(currentCountry);
    // }
    //add refresh Ads
    const dfpRefreshTimer =
      currentCountry && currentCountry === 'IN' ? 60000 : 30000;
    this.refreshDfpInterval = setInterval(() => {
      this.props.refreshDfpAdsFromRefreshableList();
    }, dfpRefreshTimer);

    if (!this.props.isAppView) {
      window.addEventListener('scroll', this.monitorScroll());
    }

    this.props.updateOpenAppUrl(this.getAppLink());

    preventCopy(this.props.isWapView);

    if (this.props.query && this.props.query.slideshow) {
      const slideshowId = this.props.query.slideshow;
      const selector = document.querySelector(
        `[data-slideshow='${slideshowId}']`,
      );
      if (selector) {
        smoothScroll(selector, 500);
      }
    }

    const articleshowData = this.props.articleData[this.props.msid];
    setGrxParams(articleshowData, {
      contentType: 'articleshow',
    });

    setPageConfigAndSendIBeatCall(articleshowData, this.props.isWapView);
    const isIPLMidArticleWidgetPresent = isIPLMidArticleWidgetsPresent(
      articleshowData,
      this.props.itemTypeKey,
    );
    if (isIPLMidArticleWidgetPresent) {
      this.setState({ isIPLMidArticleWidgetPresent });
    }

    this.handleMainArticleBlockingAndLoggedInuserCapFill();

    this.handleMainArticleTPandGA();

    // eslint-disable-next-line no-unused-expressions
    isTablet() && this.getOpenInAppSession();

    if (
      typeof window !== 'undefined' &&
      window.sessionStorage &&
      sessionStorage.getItem('planName')
    ) {
      fireCustomDimension(sessionStorage.getItem('planName'), 'dimension33');
    }
    analyticsWrapper(
      'grx',
      'send',
      'event',
      window.categoryForGA,
      'landing',
      `story_0-${window.location.href}`,
      { nonInteraction: 1 },
    );
    if (
      articleshowData &&
      articleshowData.metaInfo &&
      typeof articleshowData.metaInfo === 'object' &&
      articleshowData.metaInfo.Contenttype
    ) {
      fireCustomDimension(articleshowData.metaInfo.Contenttype, 'dimension61');
    }

    // fewcentPaywall(
    //   this.props.msid,
    //   'TOI_Articleshow',
    //   articleshowData.bc ? articleshowData.bc : '',
    //   articleshowData.ag && articleshowData.ag.toLowerCase() === 'spotlight'
    //     ? 'spotlight'
    //     : 'regular',
    //   540,
    // );
    this.setState({ isClientSide: true });
    if (!this.enablePersonalisePerpetual) {
      this.changeNextArticles();
    }

    const eventPerpectual = new Event(EVENT_NAME_ON_PERPETUAL);
    window.dispatchEvent(eventPerpectual);
    window.addEventListener('scroll', this.monitorScrollDepth());

    // if (document.referrer.indexOf('google.com') >= 0) {
    //   this.setBackButtonFunctionality();
    // }
    if (this.props.isMspArticle) {
      addMspGaTrigger();
      if (this.props.isMspUSPage) {
        window.isMspUSPage = true;
      }
      if (isOrganicArticle()) {
        this.props.setIsOrganic(true);
      }

      if (getPaidReferrer()) {
        this.props.setIsPaidTraffic(true);
      }
    }
    window.addEventListener(
      'PERPETUAL_STORYLIST_ACTION',
      this.handlePerpetualStorylistener,
    );
  }

  handlePerpetualStorylistener = () => {
    if (this.enablePersonalisePerpetual) {
      this.setState(
        {
          finalNextLinks: event.detail.persInfo,
        },
        // this.loadRelatedArticles,
        window.removeEventListener(
          'PERPETUAL_STORYLIST_ACTION',
          this.handlePerpetualStorylistener,
        ),
      );
    }
  };

  setBackButtonFunctionality = () => {
    // window.addEventListener('popstate', this.popStateEventHandler);
    if (typeof localStorage === 'object') {
      try {
        const obj = JSON.parse(
          localStorage.getItem(BACK_BUTTON_LISTING_STORAGE_NAME),
        );
        if (!obj || this.checkExpired(obj.expireTimestamp)) {
          window.addEventListener('popstate', this.popStateEventHandler);
          window.history.pushState(
            { name: 'browserBack' },
            null,
            window.location.href,
          );
          window.history.pushState(
            { name: 'browserBack' },
            null,
            window.location.href,
          );
        }
      } catch (error) {
        console.warn(error);
      }
    }
  };

  checkExpired = timeStamp => new Date().getTime() > timeStamp;

  popStateEventHandler = () => {
    setTimeout(this.popStateListener, 0);
  };

  popStateListener = () => {
    if (
      window.history &&
      window.history.state &&
      window.history.state.name === 'browserBack'
    ) {
      window.history.replaceState(null, null, window.location.href);
      const jsonObj = {
        expireTimestamp: new Date().getTime() + 24 * 60 * 60 * 1000,
      };
      localStorage.setItem(
        BACK_BUTTON_LISTING_STORAGE_NAME,
        JSON.stringify(jsonObj),
      );
      this.setState({ showBackButtonListing: true });
      window.scrollTo(0, 0);
    } else {
      window.history.back();
    }
  };

  componentWillUnmount() {
    //clear refresh Ads
    window.removeEventListener(
      'PERPETUAL_STORYLIST_ACTION',
      this.handlePerpetualStorylistener,
    );
    clearInterval(this.refreshDfpInterval);

    if (!this.props.isAppView) {
      window.removeEventListener('scroll', this.monitorScroll());
    }

    const footerAdElem = document.querySelector('.mobile-footer-ad');

    if (footerAdElem) {
      footerAdElem.classList.remove('ad_down');
    }
    window.removeEventListener('scroll', this.monitorScrollDepth());
    window.removeEventListener('popstate', this.popStateEventHandler);
    refreshEventsClearTimeout();
  }

  showPrimePopupWidget = propsToPass => {
    const frmapp =
      this.props.query &&
      (this.props.query.frmapp === 'yes' ||
        this.props.query.frmapp === 'shorts');
    if (!frmapp) {
      // return <PrimeScreen {...propsToPass} force />;
      return <PrimeScreen fcap="true" {...propsToPass} />;
    }
    return null;
  };

  getPrimeWidgets = () => {
    const { currentCountry } = this.props;
    // const prcValue =
    //   userData && userData.prcValue ? this.props.userData.prcValue : 0;

    if (currentCountry === 'IN') {
      return (
        <>
          {/* {this.shouldShowAdFreeNudge(prcValue) && (
            <AdfreeNudgeWithPopup
              userData={this.props.userData}
              page="home"
              prcValue={prcValue}
              theme="white_theme"
              showforcenudge={this.state.showforcenudge}
            />
          )} */}

          {this.showPrimePopupWidget({
            componentName: 'BottomToast',
          })}

          {/* {this.showPrimePopupWidget({
            componentName: 'SubscribeNudge',
            theme: 'white_theme',
          })} */}

          {this.showPrimePopupWidget({
            componentName: 'AddFreeSessionLoyalUsers',
            theme: 'white_theme',
          })}
        </>
      );
    }
    return null;
  };

  // getIPLMidArticleWidgets = data => {
  //   const articleshowData = data;
  //   const { widgets } = articleshowData;
  //   let returnHtml = null;
  //   if (widgets && widgets instanceof Array) {
  //     for (let i = 0; i < widgets.length; i += 1) {
  //       if (widgets[i] && widgets[i].tn === IPL_MID_ARTICLE) {
  //         returnHtml = (
  //           <ArticleshowIPLWidgetsLoadable apiURL={widgets[i].path} />
  //         );
  //         break;
  //       }
  //     }
  //   }
  //   return returnHtml;
  // };

  showAdFreeSessionPopup = articleshowData => (
    <PrimeScreen
      componentName="AddFreeSessionLoyalUsers"
      disableBlocker={articleshowData.disableLoginBlocker}
    />
  );
  // specific handing as per TOIPR-50130
  fillASReadListUptoCap() {
    const { articleToShowCount, articleToShowResetDays } = this.props;
    let i;
    // eslint-disable-next-line no-plusplus
    for (i = 0; i < articleToShowCount; i++) {
      if (
        !checkIfArticleToShowLimitBreached(
          articleToShowCount,
          articleToShowResetDays,
        )
      ) {
        addItemToArticleCounter(`x${i + 1}`);
      } else {
        break;
      }
    }

    this.fillASReadListHandled = true;
  }

  fireGaLinkandKeywordCount(msid) {
    const articleStory =
      this.props.articleData[msid] && this.props.articleData[msid].story;
    const readAlsoStroyData = articleStory.filter(
      story =>
        story[this.props.itemTypeKey] === 'keyword' ||
        story[this.props.itemTypeKey] === 'link',
    );
    if (readAlsoStroyData.length) {
      // analyticsWrapper(
      //   'ga',
      //   'send',
      //   'event',
      //   window.categoryForGA,
      //   'Hyperlink-present',
      //   `${getWebUrl(this.props.articleData[msid].wu)}`,
      //   { nonInteraction: true },
      // );
    }
  }

  checkAndAddArticleToBlockList(msid) {
    const { articleToShowCount, articleToShowResetDays } = this.props;
    const isMainArticle = this.props.msid === msid;

    if (
      articleToShowCount > 0 &&
      (this.props.articleData[msid] &&
        !this.props.articleData[msid].disableLoginBlocker)
    ) {
      if (
        checkIfArticleToShowLimitBreached(
          articleToShowCount,
          articleToShowResetDays,
        )
      ) {
        const parsedValues = getItemFromLocalStorage();
        if (typeof parsedValues === 'object') {
          const msidAlreadyRead =
            parsedValues.items && parsedValues.items.indexOf(msid) !== -1;
          if (!msidAlreadyRead) {
            const articlesToBlockList = [...this.state.articlesToBlockList];
            if (articlesToBlockList.indexOf(msid) === -1) {
              articlesToBlockList.push(msid);
              this.setState({ articlesToBlockList }, () => {
                if (isMainArticle) {
                  this.mainArticleBlockChecked = true;
                }
              });
            } else if (isMainArticle) {
              this.mainArticleBlockChecked = true;
            }
            return true;
          }
          if (isMainArticle) {
            this.mainArticleBlockChecked = true;
          }
          return false;
        }
        if (isMainArticle) {
          this.mainArticleBlockChecked = true;
        }
        return false;
      }
      addItemToArticleCounter(msid);
      if (isMainArticle) {
        this.mainArticleBlockChecked = true;
      }
      return false;
    }
    return false;
  }
  getArticleBlockedStatus(msid, isMainArticle) {
    // Status: 0: Logged In status unknown, 1: Block, -1: Unblock
    const { articleToShowCount } = this.props;

    // Unblock user if articleToShowCount is not set
    if (
      this.props.isAppView ||
      articleToShowCount <= 0 ||
      (this.props.articleData[msid] &&
        this.props.articleData[msid].disableLoginBlocker)
    ) {
      return -1;
    }
    const isLoggedinStatusKnown =
      this.props.userData &&
      typeof this.props.userData.isLoggedIn === 'boolean';
    let blockerState = 0;
    if (isLoggedinStatusKnown) {
      if (isMainArticle && !isFromDirectSource(this.props.query)) {
        blockerState = -1;
      } else if (
        (isMainArticle && this.mainArticleBlockChecked) ||
        this.state.blockerStatusCheckedArr.indexOf(msid) !== -1
      ) {
        blockerState =
          !this.props.userData.isLoggedIn &&
          this.state.articlesToBlockList &&
          this.state.articlesToBlockList.indexOf(msid) !== -1
            ? 1
            : -1;
      }
    }

    return blockerState;
  }

  handleMainArticleBlockingAndLoggedInuserCapFill() {
    const isLoggedinStatusKnown =
      this.props.userData &&
      typeof this.props.userData.isLoggedIn === 'boolean';
    if (isLoggedinStatusKnown && !this.props.isAppView) {
      if (this.props.userData.isLoggedIn) {
        if (!this.fillASReadListHandled) {
          this.fillASReadListUptoCap();
          this.mainArticleBlockChecked = true;
        }
      } else if (!this.mainArticleBlockChecked) {
        this.checkAndAddArticleToBlockList(this.props.msid);
      }
    }
  }

  showForceNudge = () => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ showforcenudge: true });
  };

  handleMainArticleTPandGA() {
    const articleBlockedStatus = this.getArticleBlockedStatus(
      this.props.msid,
      true,
    );

    // main article pageview GA custom dimension9 to be set if article is blocked

    if (!this.mainArticlePageViewGASent && articleBlockedStatus !== 0) {
      if (
        window.TimesGA &&
        window.TimesGA.setGAParams &&
        articleBlockedStatus === 1
      ) {
        window.TimesGA.setGAParams({
          dimension8: this.props.customDimension8,
          dimension9: 'articleshow_withblocker',
        });
        window.pageViewSource = 'registrationwall';
      }
      if (
        typeof window !== 'undefined' &&
        window.sessionStorage &&
        sessionStorage.getItem('planName')
      ) {
        fireCustomDimension(sessionStorage.getItem('planName'), 'dimension33');
      }
      fireCustomDimension(this.props.msid, 'dimension31');
      if (
        this.props.articleData &&
        this.props.msid &&
        this.props.articleData[this.props.msid] &&
        this.props.articleData[this.props.msid].dl
      ) {
        fireCustomDimension(
          getCustomDimension45(this.props.articleData[this.props.msid].dl),
          'dimension55',
        );
      }

      analyticsWrapper(
        'ga',
        'send',
        'pageview',
        this.props.articleData[this.props.msid].wu,
      );
      this.fireGaLinkandKeywordCount(this.props.msid);
      this.mainArticlePageViewGASent = true;
      if (articleBlockedStatus === 1) {
        analyticsWrapper(
          'gaAndGrx',
          'send',
          'event',
          window.categoryForGA,
          'Nonprime-login_blocker|View',
          `${this.getArticleSectionName(this.props.msid)}_${getWebUrl(
            this.props.articleData[this.props.msid].wu,
          )}`,
        );
      }
    }
  }

  setDfpTargetingKeyword() {
    let targetingKeyword = _get(
      this.props.articleData[this.props.msid],
      `dfpkeyword`,
    );
    targetingKeyword =
      targetingKeyword ||
      _get(this.props.articleData[this.props.msid], 'newsKws');
    if (typeof targetingKeyword !== 'string') {
      return;
    }
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(() => {
      window.googletag.pubads().setTargeting('keyword', targetingKeyword);
    });
  }
  shouldShowAdFreeNudge = prcValue => {
    let shouldShow = false;
    if (typeof window === 'object' && isPrimeNotActive(prcValue)) {
      shouldShow = true;
    }
    return shouldShow;
  };

  static updateInterstitialCount() {
    if (typeof window.updateCountForInterstitial === 'function') {
      window.updateCountForInterstitial();
    }
  }

  changeNextArticles = () => {
    const { relatedArticles } = this.props;
    if (
      relatedArticles &&
      relatedArticles.data &&
      Array.isArray(relatedArticles.data) &&
      relatedArticles.data.length > 0
    ) {
      this.setState({ finalNextLinks: relatedArticles.data });
    }
  };

  componentDidUpdate(prevProps) {
    const { currentCountry } = this.props;
    this.handleMainArticleBlockingAndLoggedInuserCapFill();
    if (
      prevProps.currentCountry !== currentCountry &&
      typeof currentCountry === 'string'
    ) {
      //clear refresh Ads
      clearInterval(this.refreshDfpInterval);

      //update refresh Ads
      const dfpRefreshTimer =
        currentCountry && currentCountry === 'IN' ? 60000 : 30000;
      this.refreshDfpInterval = setInterval(() => {
        this.props.refreshDfpAdsFromRefreshableList();
      }, dfpRefreshTimer);
    }

    if (this.props.msid !== prevProps.msid) {
      this.articlesLoaded = false;
      this.scrollVal = 0;
      this.lastDataFetchIndex = -1;
      this.tpActivityFired = false;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        activeMsid: '',
        enablePerpetual: false,
      });
      // this.props.toggleNIC(false);
      this.pageViewFiredArr = [];
      const articleshowData = this.props.articleData[this.props.msid];
      setPageConfigAndSendIBeatCall(articleshowData, this.props.isWapView);
      return;
    }

    this.handleMainArticleTPandGA();

    const activeMsid = this.state.activeMsid || this.props.msid;

    // if (this.state.activeMsid !== prevState.activeMsid) {
    //   //Close NIC on new article
    //   this.props.toggleNIC(false);
    // }

    if (
      prevProps.userData.isLoggedIn &&
      !this.props.userData.isLoggedIn &&
      !this.props.isAppView &&
      this.getArticleBlockedStatus(
        activeMsid,
        activeMsid === this.props.msid,
      ) === 1
    ) {
      analyticsWrapper(
        'gaAndGrx',
        'send',
        'event',
        window.categoryForGA,
        'Nonprime-login_blocker|View',
        `${this.getArticleSectionName(activeMsid)}_${getWebUrl(
          this.props.articleData[activeMsid].wu,
        )}`,
      );
    }
    // if (
    //   prevProps.currentCountry !== currentCountry &&
    //   typeof currentCountry === 'string' &&
    //   currentCountry === 'US'
    // ) {
    //   const nextLinkData =
    //     this.props.articleData[this.props.msid] &&
    //     this.props.articleData[this.props.msid].nextLinks;
    //   const finalNextLinks = getGeoBasesPerpectualNextLinkData(nextLinkData);

    //   // eslint-disable-next-line react/no-did-update-set-state
    //   this.setState({ finalNextLinks });
    // }
    const { userData } = this.props;
    if (typeof document !== 'undefined') {
      const iframe = document.getElementById('creditscoreiframe');
      if (
        !this.postMessageFired &&
        iframe &&
        (!prevProps.userData ||
          (typeof prevProps.userData === 'object' &&
            !('isLoggedIn' in prevProps.userData))) &&
        typeof userData === 'object' &&
        'isLoggedIn' in userData
      ) {
        postCreditScoreMessage(userData);
        this.postMessageFired = true;
      }
    }
  }

  isUserLoggedin = () => {
    const { userData } = this.props;
    let isLoggedin = false;
    if (
      userData &&
      typeof userData.getUid === 'function' &&
      userData.getUid()
    ) {
      isLoggedin = true;
    }
    return isLoggedin;
  };

  showLogin = () => {
    this.props.toggleLoginBox(true);
  };

  monitorScrollDepth = () => throttle(this.handleScrollDepth.bind(this), 100);
  monitorScroll = throttleTime =>
    throttle(this.handleScrollEvent, throttleTime);

  handleScrollEvent = () => {
    if (!this.state.enablePerpetual && !this.state.isAppView) {
      this.setState({ enablePerpetual: true });
    }
    let scrollingDown = false;
    const activeMsid = this.state.activeMsid || this.props.msid;
    let nextElement;
    let elemMsid;
    let linkObj;

    // changing the msid in tgtkeys for perpetual scroll
    if (window.tgtkeys) {
      window.tgtkeys.msid = activeMsid;
    }
    if (this.enablePersonalisePerpetual) {
      const nextLink =
        this.state.finalNextLinks && Object.keys(this.state.finalNextLinks);
      if (!this.articlesLoaded && nextLink.length > 0) {
        this.loadRelatedArticlesOnPerpetual();
      }
    } else if (
      !this.articlesLoaded &&
      !this.props.dataLoading &&
      !this.props.loadPerpetualsInView
    ) {
      this.loadRelatedArticlesOnPerpetual();
    }
    const currentScrollVal = window.pageYOffset;
    if (currentScrollVal > this.scrollVal) {
      scrollingDown = true;
    }

    setTimeout(() => {
      this.sendGAForNewsCoverage();
    }, 0);

    if (scrollingDown) {
      nextElement = document.querySelector(`#next-story-${activeMsid}`);
      if (!nextElement) {
        return;
      }
      const nextLinkIndex = nextElement.getAttribute('data-linkindex');
      if (this.state.finalNextLinks && this.state.finalNextLinks.length > 0) {
        linkObj = this.state.finalNextLinks[nextLinkIndex];
      }
      if (linkObj && linkObj.msid) {
        elemMsid = linkObj.msid;
      }
    } else if (
      !scrollingDown &&
      activeMsid !== this.props.msid &&
      this.state.finalNextLinks &&
      this.state.finalNextLinks.length > 0
    ) {
      const prevSelector = document.querySelector(`#next-story-${activeMsid}`);
      if (!prevSelector) {
        return;
      }
      const prevLinkIndex = prevSelector.getAttribute('data-prevlinkindex');
      if (prevLinkIndex === '-2') {
        return;
      }
      const prevMsid =
        prevLinkIndex === '-1'
          ? this.props.msid
          : this.state.finalNextLinks[prevLinkIndex].msid;
      nextElement = document.querySelector(`#next-story-${prevMsid}`);
      elemMsid = prevMsid;
    }
    if (!scrollingDown && this.state.nextArticleIndex !== -1) {
      this.setState({ nextArticleIndex: -1 });
    }
    this.scrollVal = currentScrollVal;
    if (nextElement) {
      this.changePageUrl(nextElement, scrollingDown, elemMsid);
    }
    this.handleGAOnScroll();
  };
  setScrollGAElements() {
    try {
      this.scrollGAElements = [
        ...document.querySelectorAll('[data-scrollga]:not([data-scrollga=""])'),
      ];
    } catch (e) {
      // console.log(e);
    }
  }

  handleGAOnScroll = () => {
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    let element = '';
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (this.scrollGAElements === undefined) {
      this.setScrollGAElements();
    }

    if (currentTop > prevTop) {
      for (let i = 0; i < this.scrollGAElements.length; i += 1) {
        if (this.scrollGAElements[i]) {
          element = this.scrollGAElements[i];
          if (this.scrollGAElements[i].classList[0]) {
            element = document.querySelector(`.${element.classList[0]}`);
          }
        }
        if (element && inViewForReact(element, 0, true)) {
          let gaData =
            this.scrollGAElements[i].getAttribute('data-scrollga') || '';

          gaData = gaData.split('#');
          const category = gaData[0] || '';
          const action = gaData[1] || '';
          const label = gaData[2] || '';
          if (category === 'WEB-articleshowv2' && action === 'scroll') {
            return;
          }
          gaWrapper('send', 'event', category, action, label, {
            nonInteraction: 1,
          });

          this.scrollGAElements[i].removeAttribute('data-scrollga');
          this.scrollGAElements.splice(i, 1);
        }
      }
    }
  };
  handleScrollDepth = () => {
    const activeMsid = this.state.activeMsid || this.props.msid;
    const articleshowData = this.props?.articleData?.[activeMsid];
    const isSpotLight =
      articleshowData?.ag && articleshowData?.ag.toLowerCase() === 'spotlight';
    const element = document.querySelector(
      `[data-articlemsid="${activeMsid}"]`,
    );
    if (element) {
      const elementRec = element.getBoundingClientRect();
      const elementTop = Math.abs(elementRec.top);
      const scrolledPercentage = Math.round(
        elementTop / elementRec.height * 100,
      );
      // console.log(elementTop);
      // console.log(elementRec.height);
      if (this.props.isEtimesArticle) {
        this.sendEtimesScrollDepthEvent(scrolledPercentage, activeMsid);
      } else {
        this.sendScrollDepthEvent(scrolledPercentage, activeMsid, isSpotLight);
      }
    }
  };
  sendScrollDepthEvent = (percent, msid, isSpotLight) => {
    let artiMsidPercent;
    let action;
    switch (true) {
      case percent >= 10 && percent < 25:
        artiMsidPercent = `${msid}_25`;
        action = 'sl_read_25%';
        break;
      case percent >= 25 && percent < 50:
        artiMsidPercent = `${msid}_50`;
        action = 'sl_read_50%';
        break;
      case percent >= 50 && percent < 75:
        artiMsidPercent = `${msid}_75`;
        action = 'sl_read_75%';
        break;
      case (percent >= 75 && percent <= 100) || percent > 100:
        artiMsidPercent = `${msid}_100`;
        action = 'sl_read_100%';
        break;
      default:
    }
    // console.log(artiMsidPercent);
    if (
      artiMsidPercent &&
      this.scrollDepthAcheivedArr.indexOf(artiMsidPercent) < 0
    ) {
      if (isSpotLight) {
        gaWrapper(
          'send',
          'event',
          'spotlight_WEB_articleshowv2',
          action,
          msid,
          {
            nonInteraction: 1,
          },
        );
      }
      if (artiMsidPercent === `${msid}_75`) {
        if (
          this.props.userData?.isLoggedIn &&
          this.props.earnPoints &&
          typeof this.props.earnPoints === 'function'
        ) {
          this.props.earnPoints({
            msid,
            actType: 'ARTICLE_SHOW',
            ssoid: this.props.userData.getUid(),
            phoneNumber: this.props.userData?.getMobile()?.Verified?.mobile,
            email: this.props.userData?.getEmail(),
          });
        }
      }
      this.scrollDepthAcheivedArr.push(artiMsidPercent);
    }
  };

  sendEtimesScrollDepthEvent = (percent, msid) => {
    let artiMsidPercent;
    let action;
    switch (true) {
      case percent >= 10 && percent < 50:
        artiMsidPercent = `${msid}_10`;
        action = '10%';
        break;
      case percent >= 50 && percent < 80:
        artiMsidPercent = `${msid}_50`;
        action = '50%';
        break;
      case (percent >= 80 && percent <= 100) || percent > 100:
        artiMsidPercent = `${msid}_80`;
        action = '80%';
        break;
      default:
    }
    if (
      artiMsidPercent &&
      this.scrollDepthAcheivedArr.indexOf(artiMsidPercent) < 0
    ) {
      sendGaThroughProps({
        data: {
          gaLabel: action,
          gaAction: 'scroll',
          nonInteraction: true,
        },
      });
      if (artiMsidPercent === `${msid}_50`) {
        if (
          this.props?.userData?.isLoggedIn &&
          this.props.earnPoints &&
          typeof this.props.earnPoints === 'function'
        ) {
          this.props.earnPoints({
            msid,
            actType: 'ARTICLE_SHOW',
            ssoid: this.props?.userData?.getUid(),
            phoneNumber: this.props?.userData?.getMobile()?.Verified?.mobile,
            email: this.props.userData?.getEmail(),
          });
        }
      }
      this.scrollDepthAcheivedArr.push(artiMsidPercent);
    }
  };

  changePageUrl = (nextElement, scrollingDown, elemMsid) => {
    const elem = document.querySelector(`[data-articlemsid="${elemMsid}"]`);
    if (!elem) {
      return;
    }
    const skew = -200;
    const isElementInView = inViewForReact(elem, skew, true);
    const origin = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }`;
    const pageUrl = window.location.href.replace(origin, '');
    let activeMsid;
    let currentIndex;
    let nextArticleIndex = 1;
    if (scrollingDown) {
      const currentPopIndex = nextElement.getAttribute('data-linkindex');
      if (!isNaN(currentPopIndex)) {
        nextArticleIndex = parseInt(currentPopIndex, 10) + 1;
      }
    }
    if (
      isElementInView &&
      this.state.finalNextLinks &&
      this.state.finalNextLinks.length > 0
    ) {
      let nextDataUrl;
      if (scrollingDown) {
        currentIndex = nextElement.getAttribute('data-linkindex');
        nextDataUrl = this.state.finalNextLinks[currentIndex].wu.replace(
          'https://timesofindia.indiatimes.com',
          '',
        );
        activeMsid = this.state.finalNextLinks[currentIndex].msid;
        if (currentIndex && parseInt(currentIndex, 10) >= 3) {
          return;
        }

        // nextArticleIndex = parseInt(currentIndex, 10) + 2;
      } else {
        currentIndex =
          parseInt(nextElement.getAttribute('data-prevlinkindex'), 10) + 1;
        if (currentIndex === -1) {
          nextDataUrl = this.props.articleData[this.props.msid].wu;
          activeMsid = this.props.msid;
        } else {
          nextDataUrl = this.state.finalNextLinks[currentIndex].wu
            .replace('https://timesofindia.indiatimes.com', '')
            .replace('https://toidev.indiatimes.com', '');
          activeMsid = this.state.finalNextLinks[currentIndex].msid;
        }

        nextDataUrl = nextDataUrl
          .replace('https://timesofindia.indiatimes.com', '')
          .replace('https://toidev.indiatimes.com', '');
      }

      if (pageUrl !== nextDataUrl) {
        // window.history.pushState({}, '', nextDataUrl);
        this.setState({
          activeMsid,
          // nextArticleIndex,
        });
        this.props.updateActiveMsid(activeMsid);
        this.props.updateOpenAppUrl(this.getAppLink());
        // document.getElementsByTagName(
        //   'title',
        // )[0].innerText = this.props.articleData[activeMsid].seo.title;
        this.changePageMeta(activeMsid, currentIndex);
        setPageConfigAndSendIBeatCall(
          this.props.articleData[activeMsid],
          this.props.isWapView,
        );
        this.fireComscore();
      }
    }

    if (scrollingDown) {
      this.setState({ nextArticleIndex });
    }

    if (this.enableNextArticleSticky) {
      try {
        const currentMsid = this.state.activeMsid || this.props.msid;
        let scrollHeightToShowPopUp = this.state[`height-${currentMsid}`];
        let shouldShowPopUp = false;
        if (!this.state[`height-${currentMsid}`]) {
          const currentArticleTop = document
            .querySelector(`[data-articlemsid="${currentMsid}"]`)
            .getBoundingClientRect().top;
          const bodyTop = document.body.getBoundingClientRect().top;
          const articleStartIndex = currentArticleTop - bodyTop;
          const currentArticleHeight =
            this.props.scrollASHeight *
            document
              .querySelector(
                `[data-articlemsid="${currentMsid}"] [data-articlebody="1"]`,
              )
              .getBoundingClientRect().height;
          scrollHeightToShowPopUp = articleStartIndex + currentArticleHeight;
          this.setState({ [`height-${currentMsid}`]: scrollHeightToShowPopUp });
        }

        if (window.scrollY > scrollHeightToShowPopUp) {
          if (!this.state.showNextArticlePopUp && scrollingDown) {
            shouldShowPopUp = true;
          } else if (this.state.showNextArticlePopUp) {
            shouldShowPopUp = true;
          }
        }

        if (!scrollingDown) {
          shouldShowPopUp = false;
        }

        if (shouldShowPopUp !== this.state.showNextArticlePopUp) {
          this.setState({ showNextArticlePopUp: shouldShowPopUp });
        }
      } catch (e) {
        // console.log(e)
      }
    }
  };

  fireComscore = () => {
    if (window.TimesApps && window.TimesApps.fireComscore) {
      window.TimesApps.fireComscore();
    }
  };

  getArticleSectionName(msid) {
    const articleshowData = this.props.articleData[msid];
    const sectionName =
      articleshowData &&
      articleshowData.navsubsecs &&
      articleshowData.navsubsecs.subsec1 &&
      articleshowData.navsubsecs.subsec1.subsecname1
        ? articleshowData.navsubsecs.subsec1.subsecname1
        : '';

    return sectionName;
  }
  fireGA4PageView = (msid, storyNumber) => {
    const articleshowData = this.props.articleData[msid];
    const sectionName = _get(articleshowData, 'navsubsecs.subsec1.subsecname1');
    const subSection = _get(articleshowData, 'navsubsecs.subsec2.subsecname2');
    const { ag, authors, dl } = articleshowData;
    const dayssincecreated = getCustomDimension45(articleshowData?.dl);
    let authorName;
    const contentType = _get(articleshowData, 'metaInfo.Contenttype');
    if (Array.isArray(authors) && authors.length > 0) {
      authorName = authors[0].name;
    }
    fireGA4ScriptPerpectual({
      vmsid: msid,
      storyNumber,
      sectionName,
      subSection,
      authorName,
      agencyName: ag,
      dayssincecreated,
      dlTimeStamp: dl,
      contentType,
    });
  };

  changePageMeta = (msid, index) => {
    if (!this.props.articleData[msid] || !this.props.articleData[msid].wu) {
      return;
    }

    const event = new Event('ARTICLECHANGEPERPECWEB');
    window.dispatchEvent(event);

    let nextDataUrl = this.props.articleData[msid].wu;
    nextDataUrl = nextDataUrl
      .replace('https://timesofindia.indiatimes.com', '')
      .replace('https://toidev.indiatimes.com', '')
      .replace('https://toireviewsstg.indiatimes.com', '')
      .replace('https://reviews.indiatimes.com', '');
    const queryParameters = window.location.href.split('?')[1];
    nextDataUrl += queryParameters ? `?${queryParameters}` : '';
    window.history.pushState({}, '', nextDataUrl);
    if (this.props.articleData[msid].seo) {
      document.title = this.props.articleData[msid].seo.title;
    } else if (
      this.props.articleData[msid] &&
      this.props.articleData[msid].wu &&
      this.props.articleData[msid].wu.includes('/spotlight') &&
      this.props.articleData[msid].hl
    ) {
      document.title = this.props.articleData[msid].hl;
    }

    let isBlocked = false;
    const { blockerStatusCheckedArr } = this.state;
    if (!this.props.userData.isLoggedIn && !this.props.isAppView) {
      isBlocked = this.checkAndAddArticleToBlockList(msid);
      if (blockerStatusCheckedArr.indexOf(msid) === -1) {
        blockerStatusCheckedArr.push(msid);
        this.setState({ blockerStatusCheckedArr });
      }
    }
    setGrxParamsRelatedToData(this.props.articleData[msid], {
      onPlatformSource: 'ArticleShowPerpetualScroll',
      contentType: 'articleshow',
    });
    if (
      typeof window !== 'undefined' &&
      window.persObj &&
      typeof window.persObj.setObserver === 'function'
    ) {
      window.persObj.setObserver();
    }
    // send ga if blocked article came into view
    if (isBlocked) {
      analyticsWrapper(
        'gaAndGrx',
        'send',
        'event',
        window.categoryForGA,
        'Nonprime-login_blocker|View',
        `${this.getArticleSectionName(msid)}_${getWebUrl(
          this.props.articleData[msid].wu,
        )}`,
      );
    }

    if (
      this.pageViewFiredArr.indexOf(msid) === -1 &&
      msid !== this.props.msid
    ) {
      const storyNumber = parseInt(index, 10) + 1;
      let perpetualGaAction = 'perpetual_scroll';
      let perpetualGaLabel = `story_${storyNumber}-${window?.location?.href}`;
      if (this.props.isEtimesArticle) {
        perpetualGaAction = `perpetual-scroll-story_${storyNumber}`;
        perpetualGaLabel = `${window?.location?.href}`;
      }
      analyticsWrapper(
        'gaAndGrx',
        'send',
        'event',
        window.categoryForGA,
        perpetualGaAction,
        perpetualGaLabel,
        { nonInteraction: 1 },
      );
      Articleshow.updateInterstitialCount();
      if (
        typeof window !== 'undefined' &&
        typeof window.perpetualAdRefresh === 'function'
      ) {
        window.perpetualAdRefresh();
      }
      if (this.props.articleData[msid]) {
        const gaData = getGAData(this.props.articleData[msid]);
        if (window.TimesGA && window.TimesGA.setGAParams) {
          window.TimesGA.setGAParams(gaData);
        }
      }
      // fireCustomDimension(this.props.msid, 'dimension31');
      // updating this as old msid was getting passed
      // fireCustomDimension(msid, 'dimension31');
      /**
       * fireCustomDimension sets both ga and grx,
       * To avoid msid from being sent in signals page view,
       * sending ga separately
       */
      analyticsWrapper('ga', 'set', 'dimension150', 'perpetual');
      analyticsWrapper('ga', 'set', 'dimension31', msid);
      analyticsWrapper('ga', 'send', 'pageview', window.location.href);
      if (typeof window?.grx_module?.hitgrxPageviewReact === 'function') {
        window.grx_module.hitgrxPageviewReact();
      }
      if (
        window.persObj &&
        typeof window.persObj.triggerPerpetualGrxEvent === 'function' &&
        this.enablePersonalisePerpetual
      ) {
        window.persObj.triggerPerpetualGrxEvent();
        window.persObj.triggerGAOnPerpetual();
      }
      this.fireGaLinkandKeywordCount(msid);
      this.pageViewFiredArr.push(msid);
      this.fireGA4PageView(msid, storyNumber);
    }
    // const artdata = this.props.articleData[msid];
    // fewcentPaywall(
    //   msid,
    //   'TOI_Articleshow',
    //   artdata.bc ? artdata.bc : '',
    //   artdata.ag && artdata.ag.toLowerCase() === 'spotlight'
    //     ? 'spotlight'
    //     : 'regular',
    //   540,
    // );
  };

  loadPerpetualArticle = (entry, url) => {
    const idStr = entry.target.querySelector('div').id;
    const msid = idStr.replace('toi-article-container-', '');
    if (msid) {
      let sectionInfo = {};
      let widgetMapping = {};
      if (this.props.isNewFeedEnabled) {
        sectionInfo = {
          sectionL1: getSectionForPathName(url),
          sectionL2: getSectionForPathName(url, 2),
        };
        widgetMapping = this.props.isEtimesArticle
          ? getEtimesWidgetMapping(sectionInfo)
          : getWidgetMapping(sectionInfo);
      }

      // for (let i = 0; i < nextLinks.length; i += 1) {
      this.props.loadArticleshowData({
        fullPath: `/articleshow/${msid}.cms`,
        isWapView: false,
        isReviewsPage: this.props.isReviewsPage,
        msid,
        sectionInfo,
        widgetMapping,
        isEtimesArticle: this.props.isEtimesArticle,
        isNewFeedEnabled: this.props.isNewFeedEnabled,
      });

      this.lastArticleLoadedIndex = this.lastArticleLoadedIndex + 1;
      // }
      this.articlesLoaded = true;
    }
  };

  loadRelatedArticlesOnPerpetual = () => {
    const nextLinks = this.state.finalNextLinks;
    if (
      nextLinks &&
      nextLinks.length &&
      nextLinks[this.lastArticleLoadedIndex]
    ) {
      let sectionInfo = {};
      let widgetMapping = {};
      if (this.props.isNewFeedEnabled) {
        sectionInfo = {
          sectionL1: getSectionForPathName(
            nextLinks[this.lastArticleLoadedIndex]?.wu,
          ),
          sectionL2: getSectionForPathName(
            nextLinks[this.lastArticleLoadedIndex]?.wu,
            2,
          ),
        };
        widgetMapping = this.props.isEtimesArticle
          ? getEtimesWidgetMapping(sectionInfo)
          : getWidgetMapping(sectionInfo);
      }
      // for (let i = 0; i < nextLinks.length; i += 1) {
      this.props.loadArticleshowData({
        fullPath: `/articleshow/${
          nextLinks[this.lastArticleLoadedIndex].msid
        }.cms`,
        isWapView: false,
        isReviewsPage: this.props.isReviewsPage,
        msid: nextLinks[this.lastArticleLoadedIndex].msid,
        sectionInfo,
        widgetMapping,
        isEtimesArticle: this.props.isEtimesArticle,
        isNewFeedEnabled: this.props.isNewFeedEnabled,
      });
      this.lastArticleLoadedIndex = this.lastArticleLoadedIndex + 1;
      // }
      this.articlesLoaded = true;
    }
  };

  loadRelatedArticles = () => {
    const nextLinks = this.state.finalNextLinks;
    if (nextLinks && nextLinks.length) {
      for (let i = 0; i < nextLinks.length; i += 1) {
        let sectionInfo = {};
        let widgetMapping = {};
        if (this.props.isNewFeedEnabled) {
          sectionInfo = {
            sectionL1: getSectionForPathName(nextLinks[i].wu),
            sectionL2: getSectionForPathName(nextLinks[i].wu, 2),
          };
          widgetMapping = this.props.isEtimesArticle
            ? getEtimesWidgetMapping(sectionInfo)
            : getWidgetMapping(sectionInfo);
        }

        this.props.loadArticleshowData({
          fullPath: `/articleshow/${nextLinks[i].msid}.cms`,
          isWapView: false,
          msid: nextLinks[i].msid,
          sectionInfo,
          widgetMapping,
          isEtimesArticle: this.props.isEtimesArticle,
          isNewFeedEnabled: this.props.isNewFeedEnabled,
        });
        this.articlesLoaded = true;
      }
    }
  };

  changeActiveArticle = (msid, index) => {
    this.setState({ activeMsid: msid });
    setTimeout(() => {
      this.changePageMeta(msid, index);
    }, 0);
  };

  getAppLink = () => {
    const activeMsid = this.state.activeMsid || this.props.msid;
    if (activeMsid && this.props.articleData[activeMsid]) {
      return _get(this.props.articleData[activeMsid], 'appdll.openinapp', '');
    }
    return '';
  };

  getCommentsData = msid => {
    let commentCount = 0;
    if (this.props.comments && this.props.comments[`commentsData-${msid}`]) {
      const commentsData = this.props.comments[`commentsData-${msid}`];
      commentCount = commentsData[0] ? commentsData[0].totalcount : 0;
    }

    return commentCount;
  };

  getComments = msid => {
    let comments = [];
    if (
      this.props.comments &&
      this.props.comments[`commentsData-${msid}-agreed`]
    ) {
      comments = this.props.comments[`commentsData-${msid}-agreed`];
      if (!(comments && comments.length)) {
        comments = [];
      }
    }

    return comments;
  };

  onSizeChange = currSize => {
    const _classes = ['small', 'medium', 'large'];
    const ele = document.querySelector('html');
    if (!ele.classList.contains(currSize)) {
      // remove all classes first and add newone
      _classes.map(x => ele.classList.remove(x));
      ele.classList.add(currSize);
    }

    this.setState({
      textSize: currSize,
    });
  };

  openSideBar = (msid, id) => {
    if (isTablet()) {
      const sidebar = document.getElementById(`comment-container-${msid}`);
      if (sidebar) {
        const val =
          window.pageYOffset + sidebar.getBoundingClientRect().top - 100;
        smoothScroll(val, 500);
      }
      return;
    }
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = '';
    this.props.openSidebar(msid, id);
    // this.props.toggleNIC(false);
  };

  // setIsStickyHeaderVisible = value => {
  //   this.setState({ isStickyHeaderVisible: value });
  // };

  setOpenInAppSession = () => {
    try {
      const expiryDate = new Date();
      expiryDate.setHours(23, 59, 59, 999);
      const day = (expiryDate - Date.now()) / (24 * 60 * 60 * 1000);
      Cookie.set('openinapp', '1', day, '/');
      sessionStorage.setItem('openinapp', '1');
    } catch (err) {
      // console.log(err);
    }
  };

  getOpenInAppSession = () => {
    try {
      if (!Cookie.get('openinapp') || sessionStorage.getItem('openinapp')) {
        this.setState({ isSessionOpenInApp: true });
      }
    } catch (err) {
      // console.log(err);
    }
  };

  openTOIApp = () => {
    const { isSessionOpenInApp, lendingImageInView } = this.state;
    if (!isSessionOpenInApp || !lendingImageInView) {
      return null;
    }
    this.setOpenInAppSession();
    return (
      <StickyOpenInApp
        getAppLink={this.getAppLink}
        isStickyShow={lendingImageInView}
      />
    );
  };

  showBlockerScreenWelcomeMsg = () => {
    // for prime users going to xslt articleshow
    setLoginSuccessInSessionStorage();

    this.setState({
      showLoginSuccessMsgAfterBlocker: true,
    });

    setTimeout(() => {
      this.setState({
        showLoginSuccessMsgAfterBlocker: false,
      });
    }, 5000);
  };
  hideBlockerScreenWelcomeMsg = () => {
    this.setState({ showLoginSuccessMsgAfterBlocker: false });
  };

  handleBlockerScreenLogin = () => {
    const { gaLabel } = this.state;
    window.loginSource = 'registrationwall';
    loginEventEmitter(
      () => {
        // send login success from blocker GA
        analyticsWrapper(
          'gaAndGrx',
          'send',
          'event',
          window.categoryForGA,
          'Nonprime-login_blocker|Login_Success',
          gaLabel,
        );
        this.showBlockerScreenWelcomeMsg();
      },
      {
        source: 'paywall',
        callOneTapSignOnPriority: true,
        // callOneTapSignOnPriority: getParameterByName('onetap') === '1',
      },
    );
  };

  sendGAForNewsCoverage = () => {
    const activeMsid = this.state.activeMsid || this.props.msid;
    let contentElem;
    if (this.state.activeMsid !== this.activeMsid) {
      contentElem = document.querySelector(
        `[data-articlemsid="${activeMsid}"] [data-insert="coverage"]`,
      );

      this.newsCoverageElem = contentElem;
    } else {
      contentElem = this.newsCoverageElem;
    }

    this.activeMsid = activeMsid;

    if (contentElem && inViewForReact(contentElem)) {
      if (!this.newsCoverageInView) {
        analyticsWrapper(
          'gaAndGrx',
          'send',
          'event',
          'MTF_coverage',
          'view',
          '',
          {
            nonInteraction: 1,
          },
        );
      }
      this.newsCoverageInView = true;
    } else {
      this.newsCoverageInView = false;
    }
  };

  // openInAppToggle = isShown => {
  //   this.props.toggleOpenInApp(isShown);
  // };
  // getIPLMidArticleWidgets = data => {
  //   const articleshowData = data;
  //   const { widgets } = articleshowData;
  //   let returnHtml = null;
  //   if (widgets && widgets instanceof Array) {
  //     for (let i = 0; i < widgets.length; i += 1) {
  //       if (widgets[i] && widgets[i].tn === IPL_MID_ARTICLE) {
  //         returnHtml = (
  //           <ArticleshowIPLWidgetsLoadable
  //             apiURL={widgets[i].path}
  //             hidePointTable={widgets[i].hidePointTable}
  //             hideFooterData={widgets[i].hideFooterData}
  //             newAS
  //           />
  //         );
  //         break;
  //       }
  //     }
  //   }
  //   return returnHtml;
  // };
  stickyAppAfterLeadingImage = val => {
    this.setState({ lendingImageInView: val });
    this.props.toggleOpenInApp(val);
  };

  getExitIntentPopup = articleshowData => {
    const section = _get(articleshowData, 'navsubsecs.subsec3.subsecmsid3');
    const subSection = _get(articleshowData, 'navsubsecs.subsec4.subsecmsid4');
    const subSectionName = _get(
      articleshowData,
      'navsubsecs.subsec4.subsecname4',
    );
    return (
      <AffiliatesContent
        // enableWidgetsOnLoad
        type="exit_intent_popup"
        filters={{
          pagename: 'msp_articleshow_v2',
          section,
          sectionmsid: subSection,
        }}
        componentProps={{
          data: {
            ga: {
              label: `${subSectionName}_${articleshowData.wu}`,
            },
          },
        }}
      />
    );
  };
  // setReadNextApiFailEventTrigger = articleId => {
  //   const { readNextApiFailEventCaptured } = this.state;
  //   this.setState({
  //     readNextApiFailEventCaptured: {
  //       ...readNextApiFailEventCaptured,
  //       [articleId]: true,
  //     },
  //   });
  // };
  atfAdCode = (val, index) => {
    const { isMspArticle, isAdRemoved } = this.props;
    if (
      this.props.commonData?.data?.ROS &&
      !isMspArticle &&
      !isAdRemoved &&
      !isTablet()
    ) {
      return (
        <div className={`${s.ad_fixplaceholder}`}>
          <LoadableComponentLoader
            loadOnScroll
            skipReRender
            loadableComponentName="Adcaller"
            delay={10}
            data={{
              name: 'masthead',
              articleIndex: index + 1,
              divId: `div-gpt-ad-atf-${index}-${val.msid}`,
            }}
            className={`${s.mobile_ads_spacing} ${
              s.atf_ad_perpetual
            } atf_ad_perpetual`}
          />
        </div>
      );
    }
    return null;
  };

  render() {
    //We are creating a new const noMsidProps Ref: https://codeburst.io/use-es2015-object-rest-operator-to-omit-properties-38a3ecffe90
    const {
      adsCampaignStatus,
      isCardCMS,
      // enableNextArticleStickyPopUp,
      msid,
      params = {},
      electionFlag,
      categoryForGA,
      isMspArticle,
      isAdRemoved,
      preloadedLeadImageHref,
      location,
      isEtimesArticle,
      topSearches,
      isReviewsPage,
      ...noMsidProps
    } = this.props;
    const isUserLoggedin = this.isUserLoggedin();
    const articleshowData = this.props.articleData[msid];
    const { prcValue = 0 } = this.props.userData;
    // eslint-disable-next-line react/prop-types
    // const { nextLinks } = articleshowData;
    let nextLinksData = this.state.finalNextLinks;
    if (nextLinksData && nextLinksData.length > 0) {
      const perpetualStoriesToLoad = Math.min(3, nextLinksData.length);
      nextLinksData = nextLinksData.slice(0, perpetualStoriesToLoad);
    }
    if (this.removeAffiliateWidget === undefined) {
      this.removeAffiliateWidget = articleshowData.removeAffiliateWidget;
    }
    const activeMsid = this.state.activeMsid || this.props.msid;
    // const articleshowDataActive = this.props.articleData[activeMsid];
    const isInfographicsArticle =
      articleshowData.contentType === 'infographicshow' ||
      articleshowData.contentType === 'infographics';

    const breadCrumbData =
      this.props.navigation && this.props.navigation.breadcrumbs
        ? this.props.navigation.breadcrumbs
        : [];
    // const topSearches =
    //   this.props.commonData && this.props.commonData?.data?.topSearches;

    if (this.props.isCardCMS) {
      return (
        <div className="cardLoader">
          <LoadableComponent
            articleData={articleshowData}
            query={this.props.query}
            msid={msid}
            isWapView={this.props.isWapView}
            isAppView={this.props.isAppView}
            blocked={this.getArticleBlockedStatus(msid, true)}
          />
        </div>
      );
    }

    if (this.state.showBackButtonListing) {
      return (
        <div className="more-content">
          <MoreStoriesLoadableComponent msid={msid} />
        </div>
      );
    }
    return (
      <React.Fragment>
        {/* <StickyHeader
          // setIsStickyHeaderVisible={this.setIsStickyHeaderVisible}
          msid={articleshowDataActive.id}
          isParent={false}
          url={articleshowDataActive.su || articleshowDataActive.wu}
          title={articleshowDataActive.hl}
          isWapView={false}
          isAppView={this.props.isAppView}
          image={
            articleshowDataActive.images
              ? articleshowDataActive.images[0]
              : undefined
          }
          openSidebar={this.openSideBar}
          commentsCount={this.getCommentsData(activeMsid)}
          wu={articleshowDataActive.wu}
          via={articleshowDataActive.via}
          isTablet={isTablet}
          commentModeration={_get(
            articleshowDataActive,
            'metaInfo.CommentModeration',
            '',
          )}
          sticky
          categoryForGA={categoryForGA}
          hideSocialSharing={isMspArticle}
          enableStickyBehavior
          ga4Data={{
            event: 'user_click',
            type: 'social_share',
            category: 'sticky_share',
          }}
        /> */}
        {/* {!isCardCMS &&
          topSearches &&
          topSearches.items &&
          topSearches.items.length > 0 && (
            <div className={s.topsearches}>
              <LinksList
                sectionData={{ ...topSearches, data: [...topSearches.items] }}
                cssSelector="astrendinglist"
                gaCategory={categoryForGA}
                gaAction="click"
                gaLabel="topSearches"
              />
            </div>
          )}
        {/* {!isCardCMS && (
          <BreadCrumb
            data={breadCrumbData}
            title={articleshowData.hl}
            wrapperClass="breadcrumb"
            showHomeIcon
          />
        )} */}

        <div
          id={`toi-article-container-${msid}`}
          className="clearfix rel"
          data-scrollga={`${categoryForGA}#scroll#scroll_starts`}
        >
          {/* <GenderPopupLoaderWithPopup /> */}
          {/* <TimesClubWidgetLoaderWithPopup isWapView={false} /> */}
          {this.getPrimeWidgets()}
          {!isTablet() &&
            this.props.articleData[msid] &&
            _get(this.props.articleData[msid], `ads.ctn.slots.NativePPD`) && (
              <AdCaller
                className={s.mobile_ads}
                data={{
                  ..._get(
                    this.props.articleData[msid],
                    `ads.ctn.slots.NativePPD`,
                    {},
                  ),
                  divId: `${
                    _get(
                      this.props.articleData[msid],
                      `ads.ctn.slots.NativePPD`,
                      {},
                    ).divId
                  }-${msid}`,
                }}
                isCTN
              />
            )
          // adsCampaignStatus &&
          // _get(adsCampaignStatus, 'PPD.status') === 1 && (
          //   <AdCaller
          //     data={{
          //       ..._get(
          //         this.props.articleData[msid],
          //         `ads.dfp.slots.PPD`,
          //         {},
          //       ),
          //       geo: _get(adsCampaignStatus, 'PPD.geo', ''),
          //       divId: `${
          //         _get(this.props.articleData[msid], `ads.dfp.slots.PPD`, {})
          //           .divId
          //       }-${msid}`,
          //       targetingInfo: {
          //         ..._get(this.props.articleData[msid], `ads.dfp.info`, {}),
          //       },
          //     }}
          //   />
          // )
          }
          <LoadableComponentLoader
            loadInView
            loadableComponentName="VideoActionControllerWeb"
            activeMsid={this.state.activeMsid}
            msid={this.props.msid}
            isTablet={isTablet}
          />
          <ArticleshowInner
            {...noMsidProps}
            msid={msid}
            isReviewsPage={isReviewsPage}
            isEtimesArticle={isEtimesArticle}
            enableNextArticleStickyPopUp={this.enableNextArticleSticky}
            showForceNudge={this.showForceNudge}
            parentMsid={this.props.msid}
            articleData={articleshowData}
            activeMsid={activeMsid}
            commentsCount={this.getCommentsData(msid)}
            commentsData={this.getComments(msid)}
            textSize={this.state.textSize}
            onSizeChange={this.onSizeChange}
            showFontAlterOptions
            openSidebar={this.openSideBar}
            // removeAffiliateWidget={this.removeAffiliateWidget}
            isUserLoggedin={isUserLoggedin}
            showLogin={this.showLogin}
            latestInfoGps={articleshowData.latestInfoGps}
            isTablet={isTablet}
            query={this.props.query}
            isInfographicsArticle={isInfographicsArticle}
            isPrivateUser={this.props.isPrivateUser}
            // exitPollData={this.props.exitPollData}
            // electionsData={this.props.electionsData}
            currentCountry={this.props.currentCountry}
            asBriefsData={this.props.asBriefsData}
            lazyMobileBodyAds={params.lazyMobileBodyAds}
            stickyAppCb={this.stickyAppAfterLeadingImage}
            nextStories={nextLinksData}
            parentStory={{
              su: articleshowData.su,
              wu: articleshowData.wu,
              msid: articleshowData.id,
              value: articleshowData.hl,
              images: articleshowData.images,
            }}
            changeActiveArticle={this.changeActiveArticle}
            allArticlesData={this.props.articleData}
            // getIPLMidArticleWidgets={this.getIPLMidArticleWidgets}
            blocked={this.getArticleBlockedStatus(msid, true)}
            prcValue={prcValue}
            handleBlockerScreenLogin={this.handleBlockerScreenLogin}
            isIPLMidArticleWidgetPresent={
              this.state.isIPLMidArticleWidgetPresent
            }
            loadedMiniTvComponent={this.props.loadedMiniTvComponent}
            electionFlag={electionFlag}
            categoryForGA={categoryForGA}
            sectionName={this.getArticleSectionName(msid)}
            articleIndex={0}
            isMspArticle={isMspArticle}
            isAdRemoved={isAdRemoved}
            abAdskey={this.props.abAdskey}
            abTestExperimentId={this.props.abTestExperimentId}
            exitIntentPopup={this.getExitIntentPopup(articleshowData)}
            rhsWidgetPriorityAS={this.props.rhsWidgetPriorityAS}
            isCardCMS={isCardCMS}
            breadCrumbData={breadCrumbData}
            breadCrumbTitle={articleshowData.hl}
            topSearches={topSearches}
            // isStickyHeaderVisible={this.state.isStickyHeaderVisible}
            preloadedLeadImageHref={preloadedLeadImageHref}
            rhsWidgetVideoAS={this.props.rhsWidgetVideoAS}
            location={location}
            isUserPrime={this.props.isUserPrime}
            showMiniTvPlayer={this.props.showMiniTvPlayer}
            // setReadNextApiFailEventTrigger={this.setReadNextApiFailEventTrigger}
            // readNextApiFailEventCaptured={
            //   this.state.readNextApiFailEventCaptured
            // }
            isMspUSPage={this.props.isMspUSPage}
            spotlightSpecificAds={this.props.spotlightSpecificAds}
            isAutoPublishedArticle={this.props.isAutoPublishedArticle}
            isSportsBeaconJs={this.props.isSportsBeaconJs}
            isPixelPlaylistID={this.props.isPixelPlaylistID}
            isCityArticle={this.props.isCityArticle}
          />
          {prcValue === PRC_FOR_NEVER_REGISTER &&
            this.showAdFreeSessionPopup(articleshowData)}
        </div>
        {articleshowData.widgets && (
          <WithTrendingVideo
            isWapView={this.props.isWapView}
            widgets={articleshowData.widgets}
            openVideoTheatre={this.props.openVideoTheatre}
            msid={this.props.msid}
          />
        )}
        {this.props.loadPerpetualsInView &&
        nextLinksData &&
        nextLinksData.length
          ? nextLinksData.map((val, index) => (
              <InViewObserver
                inViewCallback={entry => {
                  this.loadPerpetualArticle(entry, val.wu);
                }}
                viewMargin="0px 0px 900px 0px"
              >
                <div
                  id={`toi-article-container-${val.msid}`}
                  className="clearfix rel"
                  key={val.msid}
                  style={{ minHeight: '250vh' }}
                >
                  <div className="perpetual" />
                  <div
                    id={`next-story-${
                      index === 0 ? msid : nextLinksData[index - 1].msid
                    }`}
                    data-linkindex={`${index}`}
                    data-prevlinkindex={`${index - 2}`}
                  />
                  <div data-translate-id="cw" data-translate-page="1">
                    {this.props.msid !== val.msid &&
                      this.props.articleData[val.msid] &&
                      this.props.articleData[val.msid]?.story?.length > 0 && (
                        <div className={`${s.separator} clearfix`}>
                          <i />
                          <span>Up Next</span>
                        </div>
                      )}
                    {!this.props.isUserPrime && this.atfAdCode(val, index)}
                  </div>

                  {this.props.articleData[val.msid] && (
                    <>
                      <LoadableComponentLoader
                        loadInView
                        loadableComponentName="VideoActionControllerWeb"
                        activeMsid={this.state.activeMsid}
                        msid={this.props.msid}
                        isTablet={isTablet}
                      />
                      <ArticleshowInner
                        loadRelatedArticlesOnPerpetual={
                          this.loadRelatedArticlesOnPerpetual
                        }
                        {...noMsidProps}
                        perpetual
                        isReviewsPage={isReviewsPage}
                        msid={val.msid}
                        isEtimesArticle={isEtimesArticle}
                        enableNextArticleStickyPopUp={
                          this.enableNextArticleSticky
                        }
                        showForceNudge={this.showForceNudge}
                        parentMsid={this.props.msid}
                        articleData={this.props.articleData[val.msid]}
                        activeMsid={activeMsid}
                        commentsCount={this.getCommentsData(val.msid)}
                        commentsData={this.getComments(val.msid)}
                        textSize={this.state.textSize}
                        onSizeChange={this.onSizeChange}
                        showFontAlterOptions={false}
                        openSidebar={this.openSideBar}
                        adsCampaignStatus={adsCampaignStatus}
                        // removeAffiliateWidget={this.removeAffiliateWidget}
                        isUserLoggedin={isUserLoggedin}
                        showLogin={this.showLogin}
                        isTablet={isTablet}
                        query={this.props.query}
                        isInfographicsArticle={isInfographicsArticle}
                        isPrivateUser={this.props.isPrivateUser}
                        atfDivAD={this.props.commonData?.data?.ROS}
                        // exitPollData={this.props.exitPollData}
                        // electionsData={this.props.electionsData}
                        currentCountry={this.props.currentCountry}
                        nextStories={nextLinksData}
                        parentStory={{
                          su: articleshowData.su,
                          wu: articleshowData.wu,
                          msid: articleshowData.id,
                          value: articleshowData.hl,
                          images: articleshowData.images,
                        }}
                        changeActiveArticle={this.changeActiveArticle}
                        allArticlesData={this.props.articleData}
                        prcValue={prcValue}
                        blocked={this.getArticleBlockedStatus(val.msid)}
                        handleBlockerScreenLogin={this.handleBlockerScreenLogin}
                        // getIPLMidArticleWidgets={this.getIPLMidArticleWidgets}
                        isIPLMidArticleWidgetPresent={
                          this.state.isIPLMidArticleWidgetPresent
                        }
                        loadedMiniTvComponent={this.props.loadedMiniTvComponent}
                        electionFlag={electionFlag}
                        sectionName={this.getArticleSectionName(val.msid)}
                        articleIndex={index + 1}
                        hasFixedHeading={
                          index + 1 === this.state.nextArticleIndex &&
                          this.state.showNextArticlePopUp
                        }
                        abAdskey={this.props.abAdskey}
                        abTestExperimentId={this.props.abTestExperimentId}
                        isMspArticle={isMspArticle}
                        isAdRemoved={isAdRemoved}
                        rhsWidgetPriorityAS={this.props.rhsWidgetPriorityAS}
                        // isStickyHeaderVisible={this.state.isStickyHeaderVisible}
                        rhsWidgetVideoAS={this.props.rhsWidgetVideoAS}
                        isPerpetual
                        location={location}
                        isUserPrime={this.props.isUserPrime}
                        showMiniTvPlayer={this.props.showMiniTvPlayer}
                        // setReadNextApiFailEventTrigger={
                        //   this.setReadNextApiFailEventTrigger
                        // }
                        // readNextApiFailEventCaptured={
                        //   this.state.readNextApiFailEventCaptured
                        // }
                        isMspUSPage={this.props.isMspUSPage}
                        spotlightSpecificAds={this.props.spotlightSpecificAds}
                        isAutoPublishedArticle={
                          this.props.isAutoPublishedArticle
                        }
                        isCityArticle={this.props.isCityArticle}
                        loadPerpetualsInView={this.props.loadPerpetualsInView}
                      />
                    </>
                  )}
                  {this.props.articleData[val.msid] &&
                  this.props.articleData[val.msid].widgets ? (
                    <WithTrendingVideo
                      isWapView={this.props.isWapView}
                      widgets={this.props.articleData[val.msid].widgets}
                      openVideoTheatre={this.props.openVideoTheatre}
                      msid={val.msid}
                    />
                  ) : null}
                  {!this.props.articleData[val.msid] && (
                    <>
                      <LoaderSpinner overwriteLoader={s.articleLoader} />
                    </>
                  )}
                  {index === nextLinksData.length - 1 ? (
                    <div
                      id={`next-story-${nextLinksData[index].msid}`}
                      data-linkindex={`${index + 1}`}
                      data-prevlinkindex={`${index - 1}`}
                      style={{ display: 'none' }}
                    />
                  ) : null}
                </div>
              </InViewObserver>
            ))
          : null}

        {!this.props.loadPerpetualsInView &&
        nextLinksData &&
        nextLinksData.length
          ? nextLinksData.map((val, index) => (
              <div
                id={`toi-article-container-${val.msid}`}
                className="clearfix rel"
                key={val.msid}
              >
                <div className="perpetual" />
                <div
                  id={`next-story-${
                    index === 0 ? msid : nextLinksData[index - 1].msid
                  }`}
                  data-linkindex={`${index}`}
                  data-prevlinkindex={`${index - 2}`}
                />
                <div data-translate-id="cw" data-translate-page="1">
                  {this.props.msid !== val.msid &&
                    this.props.articleData[val.msid] &&
                    this.props.articleData[val.msid]?.story?.length > 0 && (
                      <div className={`${s.separator} clearfix`}>
                        <i />
                        <span>Up Next</span>
                      </div>
                    )}
                  {!this.props.isUserPrime && this.atfAdCode(val, index)}
                </div>
                {this.props.articleData[val.msid] && (
                  <>
                    <LoadableComponentLoader
                      loadInView
                      loadableComponentName="VideoActionControllerWeb"
                      activeMsid={this.state.activeMsid}
                      msid={this.props.msid}
                      isTablet={isTablet}
                    />
                    <ArticleshowInner
                      loadRelatedArticlesOnPerpetual={
                        this.loadRelatedArticlesOnPerpetual
                      }
                      {...noMsidProps}
                      isReviewsPage={isReviewsPage}
                      perpetual
                      msid={val.msid}
                      isEtimesArticle={isEtimesArticle}
                      enableNextArticleStickyPopUp={
                        this.enableNextArticleSticky
                      }
                      showForceNudge={this.showForceNudge}
                      parentMsid={this.props.msid}
                      articleData={this.props.articleData[val.msid]}
                      activeMsid={activeMsid}
                      commentsCount={this.getCommentsData(val.msid)}
                      commentsData={this.getComments(val.msid)}
                      textSize={this.state.textSize}
                      onSizeChange={this.onSizeChange}
                      showFontAlterOptions={false}
                      openSidebar={this.openSideBar}
                      adsCampaignStatus={adsCampaignStatus}
                      // removeAffiliateWidget={this.removeAffiliateWidget}
                      isUserLoggedin={isUserLoggedin}
                      showLogin={this.showLogin}
                      isTablet={isTablet}
                      query={this.props.query}
                      isInfographicsArticle={isInfographicsArticle}
                      isPrivateUser={this.props.isPrivateUser}
                      atfDivAD={this.props.commonData?.data?.ROS}
                      // exitPollData={this.props.exitPollData}
                      // electionsData={this.props.electionsData}
                      currentCountry={this.props.currentCountry}
                      nextStories={nextLinksData}
                      parentStory={{
                        su: articleshowData.su,
                        wu: articleshowData.wu,
                        msid: articleshowData.id,
                        value: articleshowData.hl,
                        images: articleshowData.images,
                      }}
                      changeActiveArticle={this.changeActiveArticle}
                      allArticlesData={this.props.articleData}
                      prcValue={prcValue}
                      blocked={this.getArticleBlockedStatus(val.msid)}
                      handleBlockerScreenLogin={this.handleBlockerScreenLogin}
                      // getIPLMidArticleWidgets={this.getIPLMidArticleWidgets}
                      isIPLMidArticleWidgetPresent={
                        this.state.isIPLMidArticleWidgetPresent
                      }
                      loadedMiniTvComponent={this.props.loadedMiniTvComponent}
                      electionFlag={electionFlag}
                      sectionName={this.getArticleSectionName(val.msid)}
                      articleIndex={index + 1}
                      hasFixedHeading={
                        index + 1 === this.state.nextArticleIndex &&
                        this.state.showNextArticlePopUp
                      }
                      abAdskey={this.props.abAdskey}
                      abTestExperimentId={this.props.abTestExperimentId}
                      isMspArticle={isMspArticle}
                      isAdRemoved={isAdRemoved}
                      rhsWidgetPriorityAS={this.props.rhsWidgetPriorityAS}
                      // isStickyHeaderVisible={this.state.isStickyHeaderVisible}
                      rhsWidgetVideoAS={this.props.rhsWidgetVideoAS}
                      isPerpetual
                      location={location}
                      isUserPrime={this.props.isUserPrime}
                      showMiniTvPlayer={this.props.showMiniTvPlayer}
                      // setReadNextApiFailEventTrigger={
                      //   this.setReadNextApiFailEventTrigger
                      // }
                      // readNextApiFailEventCaptured={
                      //   this.state.readNextApiFailEventCaptured
                      // }
                      isMspUSPage={this.props.isMspUSPage}
                      spotlightSpecificAds={this.props.spotlightSpecificAds}
                      isAutoPublishedArticle={this.props.isAutoPublishedArticle}
                      isCityArticle={this.props.isCityArticle}
                    />
                  </>
                )}
                {this.props.articleData[val.msid] &&
                this.props.articleData[val.msid].widgets ? (
                  <WithTrendingVideo
                    isWapView={this.props.isWapView}
                    widgets={this.props.articleData[val.msid].widgets}
                    openVideoTheatre={this.props.openVideoTheatre}
                    msid={val.msid}
                  />
                ) : null}
                {index === nextLinksData.length - 1 ? (
                  <div
                    id={`next-story-${nextLinksData[index].msid}`}
                    data-linkindex={`${index + 1}`}
                    data-prevlinkindex={`${index - 1}`}
                    style={{ display: 'none' }}
                  />
                ) : null}
              </div>
            ))
          : null}
        {/* {articleshowData.quickLinks ? (
          <MoreFromToi
            moreFromToidata={articleshowData.quickLinks}
            title="Quick Links"
            quicklink
            isWapView={this.props.isWapView}
          />
        ) : null} */}
        {isTablet() && !this.props.affiliatesNudgeVisible
          ? this.openTOIApp()
          : null}
        {/* {this.props.currentCountry === `IN` &&
          this.shouldShowAdFreeNudge(prcValue) && (
            <AdfreeNudgeWithPopup
              userData={this.props.userData}
              isWapView={this.props.isWapView}
              parentSocialWidgetVisible={this.state.parentSocialWidgetVisible}
              togglePerpetual={this.togglePerpetual}
              page="articleshow"
              prcValue={prcValue}
              showforcenudge={this.state.showforcenudge}
            />
          )} */}
        {this.state.showLoginSuccessMsgAfterBlocker && (
          <LoginSuccessful onClick={this.hideBlockerScreenWelcomeMsg} />
        )}
        <PopupPortal usePopupPortal={typeof window !== 'undefined'}>
          {activeMsid &&
          this.props.articleData &&
          this.props.articleData?.[activeMsid]?.audios &&
          Array.isArray(this.props.articleData?.[activeMsid]?.audios) &&
          this.props.articleData?.[activeMsid]?.audios.length > 0
            ? this.props.articleData?.[activeMsid]?.audios.map(
                (audioObj, itemIndex) =>
                  itemIndex === 0 && (
                    <InViewObserver
                      inViewCallback={() => {
                        analyticsWrapper('ga4', {
                          event: 'user_shown',
                          label: 'pause',
                          category: 'audio_summary',
                        });
                      }}
                    >
                      <div id="audioDivRef" className={s.leadaudioplayer}>
                        <Audio
                          key={`${audioObj.id}-${audioObj.playerId}`}
                          className={s.play}
                          msid={audioObj.id}
                          slikeId={audioObj.playerId}
                          isWapView
                          isVideoSkipAds
                          isUserPrime={this.props.isUserPrime}
                          userData={this.props.userData}
                          isAudioSummary
                          blockAutoplay
                          eventsCallbackMap={{
                            onVideoStarted: (eventType, eventData) => {
                              analyticsWrapper('ga4', {
                                event: 'user_click',
                                type: 'play',
                                label:
                                  eventData && eventData.muted
                                    ? 'mute'
                                    : 'unmute',
                                category: 'audio_summary',
                              });
                            },
                            onVideoPaused: (eventType, eventData) => {
                              analyticsWrapper('ga4', {
                                event: 'user_click',
                                type: 'pause',
                                label:
                                  eventData && eventData.muted
                                    ? 'mute'
                                    : 'unmute',
                                category: 'audio_summary',
                              });
                            },
                            onVolumeChange: eventData => {
                              if (typeof eventData === 'object') {
                                analyticsWrapper('ga4', {
                                  event: 'user_click',
                                  type: eventData.muted ? 'mute' : 'unmute',
                                  category: 'audio_summary',
                                });
                              }
                            },
                          }}
                        />
                      </div>
                    </InViewObserver>
                  ),
              )
            : null}
        </PopupPortal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isNicOpen: state.articleshow_v2.isNicOpen,
  userData: state.login.userData,
  articleData: state.articleshow_v2.data,
  dataLoading: state.articleshow_v2.dataLoading,
  activeNicUrl: state.articleshow_v2.nic
    ? state.articleshow_v2.nic.url
    : undefined,
  comments: state.comments,
  adsCampaignStatus: state.adCaller.adsCampaignStatus,
  isUserPrime: state.isPrime,
  isVideoTheatreOpen: state.articleshow_v2.isVideoTheatreOpen,
  videoTheatreSliderPath: state.articleshow_v2.videoTheatreSliderPath,
  videoTheatreSliderData: state.articleshow_v2.videoTheatreSliderData,
  isPrivateUser: state.gdpr.isPrivateUser,
  currentCountry: state.geo.currentCountry,
  tpinitialized: state.timesPoint && state.timesPoint.tpinitialized,
  // exitPollData: state.articleshow_v2.exitPollData,
  asBriefsData: state.articleshow_v2.asBriefsData,
  // electionsData: state.articleshow_v2.electionsData,
  navigation: state.header.data && state.header.data.navigation,
  commonData: state.commonData,
  loadedMiniTvComponent: state.miniTv?.data?.status === '1',
  articleToShowCount: state.articleshow_v2.articleToShowCount,
  articleToShowResetDays: state.articleshow_v2.articleToShowResetDays,
  affiliatesNudgeVisible: _get(state, 'affiliates.saleNudgeVisible'),
  // relatedArticles: state.articleshow_v2.relatedArticles,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // toggleNIC: isOpen => {
  //   dispatch(toggleNIC(isOpen));
  // },
  // loadNIC: url => {
  //   dispatch(loadNIC(url));
  // },
  // setNICLabel: text => {
  //   dispatch(setNICLabel(text));
  // },
  loadArticleshowData: params => {
    if (ownProps.isNewFeedEnabled) {
      Promise.all([
        dispatch(loadArticleshowDataNew(params)),
        dispatch(loadNewSectionInfo(params)),
      ]).then(() => {
        dispatch(populateArticleshowWidgets(params));
      });
    } else {
      dispatch(loadArticleshowData(params));
    }
  },
  updateActiveMsid: msid => {
    dispatch(updateActiveMsid(msid));
  },
  openSidebar: (params, id) => {
    dispatch(openSidebar(params, id));
  },
  toggleLoginBox: params => {
    dispatch(toggleLoginBox(params));
  },

  refreshDfpAdsFromRefreshableList: params => {
    dispatch(refreshDfpAdsFromRefreshableList(params));
  },
  updateOpenAppUrl: data => {
    dispatch(updateOpenAppUrl(data));
  },
  openVideoTheatre: (sliderPath, currId, currItem) => {
    dispatch(openVideoTheatre(sliderPath, currId, currItem));
  },
  closeVideoTheatre: () => {
    dispatch(closeVideoTheatre());
  },
  loadVideoTheatreSlider: (url, isWapView) => {
    dispatch(loadVideoTheatreSlider(url, isWapView));
  },
  addNextVideoMsid: (msidForNextVideo, slikeId) => {
    dispatch(addNextVideoMsid(msidForNextVideo, slikeId));
  },
  showMiniTvPlayer: isShown => {
    dispatch(showMiniTvPlayer(isShown));
  },
  toggleOpenInApp: isShown => {
    dispatch(toggleOpenInApp(isShown));
  },
  setIsOrganic: isOrganic => {
    dispatch(setIsOrganic(isOrganic));
  },
  setIsPaidTraffic: isPaidTraffic => {
    dispatch(setIsPaidTraffic(isPaidTraffic));
  },
  earnPoints: data => {
    dispatch(earnAboundPoints(data));
  },
});

Articleshow.propTypes = {
  isWapView: PropTypes.bool,
  userData: PropTypes.shape({}),
  msid: PropTypes.string.isRequired,
  isAppView: PropTypes.bool,
  query: PropTypes.shape({}),
  videoTheatreSliderData: PropTypes.arrayOf({}),
  isPrivateUser: PropTypes.bool,
  tpinitialized: PropTypes.bool,
  // exitPollData: PropTypes.shape({}),
  // electionsData: PropTypes.shape({}),
  navigation: PropTypes.shape({}),
  currentCountry: PropTypes.string.isRequired,
  commonData: PropTypes.shape({}),
  articleToShowCount: PropTypes.number,
  articleToShowResetDays: PropTypes.number,
  isCardCMS: PropTypes.bool,
  categoryForGA: PropTypes.string,
  affiliatesNudgeVisible: PropTypes.bool.isRequired,
  // relatedArticles: PropTypes.shape({}),
  abAdskey: PropTypes.string,
  abTestExperimentId: PropTypes.shape({}),
  refreshTime: PropTypes.number,
  isMspArticle: PropTypes.bool,
  scrollASHeight: PropTypes.number,
  rhsWidgetPriorityAS: PropTypes.shape({}),
  preloadedLeadImageHref: PropTypes.string,
  isAdRemoved: PropTypes.bool,
  rhsWidgetVideoAS: PropTypes.bool,
  location: PropTypes.string,
  isUserPrime: PropTypes.bool,
  isEtimesArticle: PropTypes.bool,
  isMspUSPage: PropTypes.bool,
  isCityArticle: PropTypes.bool,
  spotlightSpecificAds: PropTypes.bool,
  setIsOrganic: PropTypes.func,
  setIsPaidTraffic: PropTypes.func,
  isAutoPublishedArticle: PropTypes.bool,
  isSportsBeaconJs: PropTypes.bool,
  loadPerpetualsInView: PropTypes.bool,
  itemTypeKey: PropTypes.string,
  itemSubtypeKey: PropTypes.string,
  isReviewsPage: PropTypes.bool,
  isPixelPlaylistID: PropTypes.string,
};

Articleshow.defaultProps = {
  isWapView: false,
  isAppView: false,
  userData: {},
  query: {},
  videoTheatreSliderData: undefined,
  isPrivateUser: true,
  tpinitialized: false,
  // exitPollData: {},
  // electionsData: {},
  navigation: {},
  commonData: {},
  articleToShowCount: 0,
  articleToShowResetDays: 30,
  isCardCMS: false,
  categoryForGA: '',
  // relatedArticles: {},
  abAdskey: '',
  abTestExperimentId: {},
  refreshTime: 0,
  isMspArticle: false,
  scrollASHeight: 0.5,
  rhsWidgetPriorityAS: undefined,
  preloadedLeadImageHref: '',
  isAdRemoved: false,
  rhsWidgetVideoAS: true,
  location: '',
  isUserPrime: false,
  isEtimesArticle: false,
  isMspUSPage: false,
  isCityArticle: false,
  spotlightSpecificAds: false,
  setIsOrganic: () => {},
  setIsPaidTraffic: () => {},
  isAutoPublishedArticle: false,
  isSportsBeaconJs: false,
  isReviewsPage: false,
  loadPerpetualsInView: false,
  itemTypeKey: 'tn',
  itemSubtypeKey: 'type',
  isPixelPlaylistID: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(Articleshow);
